<template>
	<div>
		<b-form @submit="onSubmit" @reset="onReset" v-if="show">
			<b-form-row>
				<b-col>
					<b-form-group label="Letnica rojstva">
						<b-form-select
							v-model="form.birthyear"
							:options="yearOptions"
							required
							id="year-select"
						></b-form-select>
						<b-form-text id="password-help-block">
							Sodelovanje na voljo zgolj osebam, ki so starejše od 15 let.
						</b-form-text>
					</b-form-group>
				</b-col>
			</b-form-row>
			<b-form-row class="">
				<b-col>
					<b-form-group label="Spol">
						<b-form-radio-group
							required
							id="radio-sex"
							v-model="form.sex"
							:options="sexOptions"
							buttons
							button-variant="secondary"
							name="radio-sex"
						></b-form-radio-group>
					</b-form-group>
				</b-col>
			</b-form-row>

			<b-form-row>
				<b-col>
					<b-form-checkbox
						id="checkbox-1"
						v-model="form.termsagree"
						name="checkbox-1"
						value="1"
						unchecked-value="1"
						required
						class="small"
					>
						Strinjam se s
						<b-link target="_blank" href="https://brevisvelox.com/#/terms"
							>Splošnimi pogoji</b-link
						>
						in
						<b-link target="_blank" href="https://brevisvelox.com/#/privacy"
							>Politiko zasebnosti</b-link
						>.
					</b-form-checkbox>
				</b-col>
			</b-form-row>
			<b-form-row class="mt-4">
				<b-col>
					<b-button type="submit" variant="primary"
						>Pričnite z raziskavo</b-button
					>
				</b-col>
			</b-form-row>
		</b-form>
		<b-sidebar id="sidebar-terms" shadow right lazy width="50rem" backdrop>
			TERMS!
		</b-sidebar>
		<b-sidebar id="sidebar-privacy" shadow right lazy width="50rem" backdrop>
			PRIVACY
		</b-sidebar>
	</div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
	components: {},
	data() {
		return {
			show: true,
			form: {
				checked: [],
				sex: "",
				birthyear: "",
				income: 0,
				relationshipstatus: 0,
				termsagree: "",
			},
			yearOptions: [],
			sexOptions: [
				{ text: "M", value: 1 },
				{ text: "Ž", value: 2 },
			],
			wealthOptions: [
				{ text: "< 1000", value: 1 },
				{ text: "1000 - 2000", value: 2 },
				{ text: "> 2000", value: 3 },
			],
			relationshipOptions: [
				{ text: "Poročen", value: 3 },
				{ text: "V zvezi", value: 2 },
				{ text: "Samski", value: 1 },
			],
		};
	},
	computed: {
		...mapGetters({
			currentPackage: "api/getCurrentPackage",
			packageProjects: "api/getPackageProjects",
		}),
	},
	created() {},
	mounted() {
		this.birthYears();
	},
	methods: {
		birthYears() {
			// no youngers than 15
			let currentYear = new Date().getFullYear() - 16;
			let startYear = 1920;
			let years = [];
			while (startYear <= currentYear) {
				years.push(startYear++);
			}
			years.sort(function (a, b) {
				return b - a;
			});
			this.yearOptions = years;
		},

		onSubmit(evt) {
			evt.preventDefault();

			this.isSending = true;

			this.form.package_id = this.currentPackage.id;

			return new Promise((resolve, reject) => {
				axios({
					url: `${this.$store.state.login.url}/api/package/slug/${this.currentPackage.slug}/respondents/new`,
					headers: {
						Authorization: `Bearer ${this.$store.state.login.token}`,
						"Content-Type": "application/json",
					},
					data: JSON.stringify(this.form),
					method: "POST",
				})
					.then((response) => {
						// cleanup form
						this.isSending = false;

						this.$store.commit("api/respondent_success", response.data.id);

						this.$router.push({
							name: "PackageForm",
							params: { packageSlug: this.currentPackage.slug },
						});
						resolve(response);
					})
					.catch((err) => {
						this.isSending = false;
						this.$bvToast.toast(err.message, {
							title: "Something went wrong ... ",
							autoHideDelay: 5000,
						});
						reject(err);
					});
			});
		},
		onReset(evt) {
			evt.preventDefault();
			for (var member in this.form) delete this.form[member];

			// Trick to reset/clear native browser form validation state
			this.show = false;
			this.$nextTick(() => {
				this.show = true;
			});
		},
	},
};
</script>
